import { Pill } from "@/components/design-system"
import { useReplayStore } from "@/stores/replayStore"
import { useReplayTransport } from "@/hooks/useReplayTransport"
import { ReplayStartMenu } from "./ReplayStartMenu"

export function ReplayPill() {
  const isReplayMode = useReplayStore((s) => s.isReplayMode)
  const isActive = useReplayStore((s) => s.isActive)
  const { exit, beginFromDate } = useReplayTransport()

  const replayActive = isActive || isReplayMode

  if (replayActive) {
    return (
      <Pill
        id="replay-exit-btn"
        label="Replay"
        variant="button"
        onClick={exit}
        style={{ marginRight: 8 }}
      />
    )
  }

  return (
    <ReplayStartMenu onConfirm={beginFromDate}>
      <Pill
        id="replay-enter-btn"
        label="Replay"
        variant="button"
        style={{ marginRight: 8 }}
      />
    </ReplayStartMenu>
  )
}
